import type { RestApiUserGroups } from '@/interfaces/ApiRest.generated.interfaces'
import type { UsersAndGroups } from '@/contexts/shared/users/Users.interfaces'
import { USER_GROUP_TYPE } from '@/contexts/shared/users/Users.constants'

export const getUsersAndGroupsFromApi = (data: RestApiUserGroups): UsersAndGroups => {
  const processedData: UsersAndGroups = { users: [], groups: [] }

  for (const user of data.users) {
    processedData.users.push({
      id: user.id,
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      type: USER_GROUP_TYPE.USER,
    })
  }

  for (const group of data.groups) {
    processedData.groups.push({
      id: group.id,
      name: group.name,
      email: group.email ?? undefined,
      type: USER_GROUP_TYPE.GROUP,
    })
  }

  return processedData
}
